import type { MerchantError } from '~/utils/errors';

export const useGlobalMerchantError = () => {
	return useState<MerchantError | null>('global-merchant-error', () => null);
};
